import React, { Component } from "react";
import {
  message,
  Modal,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  notification,
  Space,
  Upload,
  Switch,
  Typography,
  Popconfirm,
  Tooltip,
  Input,
  Tag,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  round2Decimals,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  round6Decimals,
  ErrorItem,
  round10Decimals,
  calcularAjusteAutomaticoFactura,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { UploadOutlined, CalculatorOutlined, ArrowLeftOutlined, FileSearchOutlined, InfoCircleOutlined, EnvironmentOutlined, CarOutlined, ShopOutlined, ContactsOutlined, ToolOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import xmlToJson from "../../../../Components/xmlToJson";
import ModalDiagnosticoCuadre from "../../../../Components/ModalDiagnosticoCuadre";
import {
  leerCfdiParaDiagnostico,
  construirCapturadoDesdeTotales,
  diagnosticarCuadreFactura,
} from "../../../../Utils/diagnosticoCuadreFactura";
import decodeHTMLEntities from "../../../../Components/decodeHtmlEntities";
import { calcularTopeConTolerancia, resolverInsumoMaestroFrontend, estiloInputConTolerancia } from "../../../../Utils/OrdenDeCompra.utils";
import ManualMatchModal from "./ManualMatchModal/ManualMatchModal";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import SeleccionarXmlModal from "./SeleccionarXmlModal";
import RelacionarEntregasModal from "../RelacionarEntregasModal/RelacionarEntregasModal";
import { esUuidSat } from "../../../../Utils/uuidFactura";
import { avisarRegimenYObjetoImpXml } from "../../../../Utils/avisosFiscalesXmlRecibido";
import {
  descomponerDescuento,
  normalizarDescuentoFila,
  sincronizarDescuentoFila,
} from "../../../../Utils/descuentoEscuela";

const { Option } = Select;

moment.locale("es");

class RecibirFactura extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosOrdenDeCompra: undefined,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    id: this.props.location.state.id,
    empresaRfc: null,
    xmltotales: null,
    xmlFile: null,
    // Desglose completo del CFDI (conceptos, traslados, retenciones, implocal) para el
    // diagnostico de cuadre. xmltotales solo guarda SubTotal y Total.
    xmlDiagnostico: null,
    modalDiagnosticoVisible: false,
    diagnostico: null,
    ajusteContexto: null,
    emparejarVisible: false,
    seleccionarXmlVisible: false,
    conceptosXML: [], // { idx, clave, descripcion, cantidad, valorUnitario, descuento, impuestos }
    odcPendientes: [], // clonado de form insumos con cantidades pendientes
    mapeos: [], // { xmlIdx, odcIdx, cantidadARecibir, precioFuente: 'XML'|'ODC'|'Otro', precioOtro, usarDescuentoXML: true, motivo: '...' }
    xmlParseBasico: null, // atributos del comprobante si sirve reusar
    mostrarDetalles: true,
    ocUsoDeCfdi: null,
    ocFormaDePago: null,
    ocMetodoPago: null,
    todasUsosDeCFDI: [],
    todasFormasDePago: [],
    xmlCfdi: null,
    crearAjusteAlCosto: false,
    editarOC: false,
    estadoFactura: null,
    estadoOC: null,
    hayDiferenciasPrecios: false,
    editarOCUnicamentePrecios: false,
    uuidDuplicado: false,
    mensajeUuidDuplicado: undefined,
    // Entregas de material que esta factura ampara. Vive en el state y NO en el Form:
    // no es un valor por campo sino una subcoleccion, y asi nunca se cruza con el
    // arreglo recepciones[] heredado que el form arrastra dentro de values.insumos[].
    entregasVisible: false,
    entregasSeleccionadas: {},
  };
  componentDidMount() {
    this.consultarTodo();
    if (
      this.props?.location?.state?.fileName &&
      this.props?.location?.state?.fileData
    ) {
      this.leerXmlData(this.props.location.state);
    }
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ordenesdecompra/datosOrdenPRecibirP",
        {
          empresaId: this.props.empresaId,
          ordenDeCompraId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            {
              datosOrdenDeCompra: res.data.ordenDeCompra,
              todasUsosDeCFDI: res.data.usosDeCFDI || [],
              todasFormasDePago: res.data.formasDePago || [],
              ocUsoDeCfdi: res.data.usosDeCFDI?.find(
                (v) => v._id?.toString() === res.data.ordenDeCompra.usoDeCfdiId?.toString()
              ) || null,
              ocFormaDePago: res.data.formasDePago?.find(
                (v) => v._id?.toString() === res.data.ordenDeCompra.formaDePagoId?.toString()
              ) || null,
              ocMetodoPago: res.data.ordenDeCompra.metodoPago ?? null,
              todasInsumos: res.data.insumos,
              objetoInsumos: res.data.insumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.descripcion || value.nombre || value.stringBuscar}
                  </Option>
                );
              }),
              todasProveedores: res.data.proveedores,
              objetoProveedores: res.data.proveedores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              todasMonedas: res.data.monedas,
              objetoMonedas: res.data.monedas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.abreviacion}
                  </Option>
                );
              }),
              estadoFactura: res.data?.ordenDeCompra?.estadoFactura,
              estadoOC: res.data?.ordenDeCompra?.estado,
            },
            () => {
              this.formRef.current.setFieldsValue({
                insumos: res.data.ordenDeCompra.insumos.map((value) => {
                  const fila = {
                    ...value,
                    recibidoFacturas: value.recibidoFacturas
                      ? value.recibidoFacturas
                      : 0,
                    precioUnitarioAjustadoOC:
                      value.precioUnitario * (1 - (value.descuento / 100)),
                  };
                  // Complemento Escuela: el renglon trae el desglose de la O/C; si no
                  // lo tiene, su descuento se muestra como adicional.
                  return this.props.escuela ? normalizarDescuentoFila(fila) : fila;
                }),
                tipoDeCambio:
                  res.data.ordenDeCompra?.monedaId?.toString() ===
                    "60c7e4396465ad440c41c15a"
                    ? 1
                    : undefined,
                diasCredito: res.data.ordenDeCompra.proveedor.diasCredito || 0,
                fechaPago: moment().add(
                  res.data.ordenDeCompra.proveedor.diasCredito,
                  "days"
                ),
                fechaFactura: moment(),
                monedaId: res.data.ordenDeCompra?.monedaId,
              });
              this.setState({
                proveedorExtranjero:
                  res.data.proveedores[0]?.proveedorExtranjero || false,
              });
            }
          );
        } else {
          message.error(
            "Error no se encontro informacion de la orden de compra"
          );
        }
      });

    const responseConfiguracion = axios.post(
      "empresas/selectConfiguracionGeneralParaFacturas",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responses = await Promise.all([responseConfiguracion]);

    let newState = {};

    if (responses[0].data.status === 404) {
      message.error("Error no se encontro configuracion de esta empresa");
    } else {
      newState.empresaRfc = responses[0].data.rfc;
      newState.ajusteMax = responses[0].data.ajusteMax;
    }
    this.setState({ loading: false, ...newState });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  // Complemento Escuela: Desc. Prov. y Desc. Adic. alimentan `descuento` (su
  // cascada), que es el unico que entra en el calculo.
  onChangeDescuentoEscuela = (index) => {
    const insumos = this.formRef.current.getFieldValue("insumos");
    if (!insumos?.[index]) return;
    sincronizarDescuentoFila(insumos[index]);
    this.formRef.current.setFieldsValue({ insumos });
  };
  // Renglones que esta factura realmente esta facturando, para el modal de entregas.
  // Se lee del form en el momento de abrir; no necesita ser reactivo.
  renglonesConCantidadAFacturar() {
    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    return insumos
      .filter((valueInsumo) => (valueInsumo.recibir || 0) > 0)
      .map((valueInsumo) => ({
        insumoOrdenId: valueInsumo._id,
        nombreInsumo:
          this.state.todasInsumos.find(
            (valueTodos) => valueTodos._id === valueInsumo.insumoId
          )?.descripcion || "Insumo",
        cantidadAFacturar: valueInsumo.recibir || 0,
      }));
  }
  abrirRelacionarEntregas() {
    const renglones = this.renglonesConCantidadAFacturar();
    if (renglones.length === 0) {
      return message.info(
        "Captura primero las cantidades a facturar para poder relacionar entregas"
      );
    }
    this.setState({ entregasVisible: true });
  }
  // Descarta lo ligado a renglones que ya no se estan facturando: el usuario pudo
  // bajar la cantidad a 0 despues de haber ligado.
  construirEntregasRelacionadas(insumosFactura) {
    const renglonesVivos = new Set(
      insumosFactura
        .filter((valueInsumo) => (valueInsumo.cantidad || 0) > 0)
        .map((valueInsumo) => valueInsumo._id?.toString())
    );
    return Object.values(this.state.entregasSeleccionadas).filter((valueSeleccion) =>
      renglonesVivos.has(valueSeleccion.insumoOrdenId?.toString())
    );
  }
  // Fecha desde la que corren los dias de credito: la de recepcion con el complemento
  // vencimientoDesdeRecepcionFactura; si no, la de la factura, como siempre.
  fechaBaseVencimiento() {
    return moment(
      this.formRef.current.getFieldValue(
        this.props.vencimientoDesdeRecepcionFactura ? "fechaRecepcion" : "fechaFactura"
      )
    );
  }
  onFinish(values) {
    if (this.state.uuidDuplicado) {
      return message.error(
        this.state.mensajeUuidDuplicado ||
        "No se puede registrar: la factura ya existe en el sistema"
      );
    }
    let recibirTodos = 0;
    values.insumos = values.insumos.map((value) => {
      let recibir = value.recibir ? value.recibir : 0;
      recibirTodos += recibir;
      return { ...value, recibir };
    });
    if (recibirTodos === 0)
      return message.info(
        "Se neceitan cantidades para poder hacer esta operación"
      );
    if (this.state.crearAjusteAlCosto) message.info('Se creará un ajuste al costo por las diferencias capturadas en los ajustes')
    if (this.state.editarOC) message.info('Se editará la orden de compra')
    this.setState({ loading: true });
    let arrayInsumos = values.insumos;
    let proveedorId = this.state.datosOrdenDeCompra.proveedorId;
    let cuentasProveedor = 0;
    let subtotal = 0;
    let arrayImpuestos = [];
    let arrayRetenciones = [];
    let total = 0;
    let arrayInsumosFactura = arrayInsumos.map((valueInsumo, indexInsumo) => {
      const insumo = this.state.todasInsumos.find(
        (valueIn) => valueIn._id === valueInsumo.insumoId
      );
      let valuePrecioUnitario = valueInsumo.precioUnitario;
      let valueCantidad = valueInsumo.recibir;
      let valueDescuento = valueInsumo.descuento;

      //1
      let subtotalInsumoSD = round2Decimals(
        valuePrecioUnitario * valueCantidad
      );
      //2
      let totalDescuento = round2Decimals(
        subtotalInsumoSD * (valueDescuento / 100)
      );
      //3
      let subtotalInsumo = round2Decimals(subtotalInsumoSD - totalDescuento);

      let precioUnitarioAjustado = round10Decimals(valuePrecioUnitario * (1 - (valueInsumo.descuento / 100)))

      subtotal += subtotalInsumo;
      let totalImpuestosInsumo = 0;
      if (!this.state.proveedorExtranjero) {
        insumo.impuestos.map(
          //4
          (valueImpuesto) => {
            let descripcionFacturaImpuesto = valueImpuesto.descripcionFactura;
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
              totalImpuesto = round6Decimals(
                arrayInsumos[indexInsumo].recibir *
                precioUnitarioAjustado *
                (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 2) {
              totalImpuesto = round6Decimals(
                (arrayInsumos[indexInsumo].recibir *
                  precioUnitarioAjustado +
                  totalImpuestosInsumo) *
                (valueImpuesto.monto / 100)
              );
            } else if (valueImpuesto.tasaCuota === 3) {
              totalImpuesto = round6Decimals(
                arrayInsumos[indexInsumo].recibir * valueImpuesto.monto
              );
            } else if (valueImpuesto.tasaCuota === 4) {
              totalImpuesto = round6Decimals(
                arrayInsumos[indexInsumo].impuestos *
                (arrayInsumos[indexInsumo].recibir /
                  arrayInsumos[indexInsumo].cantidad)
              );
            } else if (valueImpuesto.tasaCuota === 5) {
              totalImpuesto = 0;
            }
            let totalImpuestosImpuesto = totalImpuesto;
            let index = arrayImpuestos.findIndex(
              (valueImpuestosAnterios) =>
                valueImpuestosAnterios.descripcionFactura ===
                descripcionFacturaImpuesto
            );
            totalImpuestosInsumo += totalImpuestosImpuesto;
            if (index !== -1) {
              let newItem = {
                totalImpuestos:
                  arrayImpuestos[index].totalImpuestos + totalImpuestosImpuesto,
                descripcionFactura: descripcionFacturaImpuesto,
              };
              arrayImpuestos.splice(index, 1, newItem);
            } else {
              arrayImpuestos.push({
                totalImpuestos: totalImpuestosImpuesto,
                descripcionFactura: descripcionFacturaImpuesto,
              });
            }
            return null;
          }
        );
      }
      if (proveedorId) {
        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        let totalRetencionesInsumo = 0;

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          let descripcionFacturaRetencion = valueRetencion.descripcionFactura;

          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              arrayInsumos[indexInsumo].recibir *
              precioUnitarioAjustado *
              (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (arrayInsumos[indexInsumo].recibir *
                precioUnitarioAjustado +
                totalRetencionesInsumo) *
              (valueRetencion.monto / 100)
            );
          }
          let index = arrayRetenciones.findIndex(
            (valueretencionesAnterios) =>
              valueretencionesAnterios.descripcionFactura ===
              descripcionFacturaRetencion
          );
          totalRetencionesInsumo += totalRetencion;
          cuentasProveedor += totalRetencion;
          if (index !== -1) {
            let newItem = {
              totalRetenciones:
                arrayRetenciones[index].totalRetenciones + totalRetencion,
              descripcionFactura: descripcionFacturaRetencion,
            };
            arrayRetenciones.splice(index, 1, newItem);
          } else {
            arrayRetenciones.push({
              totalRetenciones: totalRetencion,
              descripcionFactura: descripcionFacturaRetencion,
            });
          }
          return null;
        });

        if (!this.state.proveedorExtranjero) {
          insumo.retenciones.map((valueRetencion) => {
            if (
              (valueRetencion.aplicaCompra === 1 &&
                proveedor.persona === false) ||
              (valueRetencion.aplicaCompra === 2 &&
                proveedor.persona === true) ||
              valueRetencion.aplicaCompra === 3
            ) {
              //7
              let totalRetencion;
              let descripcionFacturaRetencion =
                valueRetencion.descripcionFactura;

              if (valueRetencion.tasaCuota === 1) {
                totalRetencion = round6Decimals(
                  arrayInsumos[indexInsumo].recibir *
                  precioUnitarioAjustado *
                  (valueRetencion.monto / 100)
                );
              } else if (valueRetencion.tasaCuota === 2) {
                totalRetencion = round6Decimals(
                  (arrayInsumos[indexInsumo].recibir *
                    precioUnitarioAjustado +
                    totalRetencionesInsumo) *
                  (valueRetencion.monto / 100)
                );
              }
              let index = arrayRetenciones.findIndex(
                (valueretencionesAnterios) =>
                  valueretencionesAnterios.descripcionFactura ===
                  descripcionFacturaRetencion
              );
              totalRetencionesInsumo += totalRetencion;
              cuentasProveedor += totalRetencion;
              if (index !== -1) {
                let newItem = {
                  totalRetenciones:
                    arrayRetenciones[index].totalRetenciones + totalRetencion,
                  descripcionFactura: descripcionFacturaRetencion,
                };
                arrayRetenciones.splice(index, 1, newItem);
              } else {
                arrayRetenciones.push({
                  totalRetenciones: totalRetencion,
                  descripcionFactura: descripcionFacturaRetencion,
                });
              }
            }
            return null;
          });
        }
      }
      //5
      let totalInsumo = round2Decimals(subtotalInsumo + totalImpuestosInsumo);
      total += subtotalInsumo;
      return {
        ...valueInsumo,
        cantidad: valueInsumo.recibir,
        subtotal: subtotalInsumo,
        total: totalInsumo,
      };
    });
    subtotal += values.ajusteSubtotal;
    total += values.ajusteSubtotal;
    arrayImpuestos = arrayImpuestos.map((valueImpuesto) => {
      let ajusteImpuesto = values["ajuste" + valueImpuesto.descripcionFactura] || 0;
      total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto);
      return {
        ...valueImpuesto,
        ajusteImpuesto,
        totalImpuestos: round2Decimals(
          valueImpuesto.totalImpuestos + ajusteImpuesto
        ),
      };
    });
    arrayRetenciones = arrayRetenciones.map((valueRetencion) => {
      let ajusteRetencion =
        values["ajuste" + valueRetencion.descripcionFactura] || 0;
      cuentasProveedor += ajusteRetencion;
      return {
        ...valueRetencion,
        ajusteRetencion,
        totalRetenciones: valueRetencion.totalRetenciones + ajusteRetencion,
      };
    });
    if (
      round2Decimals(
        round2Decimals(this.state?.xmltotales?.Total || 0) - round2Decimals(total - cuentasProveedor)
      ) !== 0 &&
      this.state.xmltotales &&
      !this.state.estadoCC
    ) {
      this.setState({ loading: false });
      return message.error(
        'El total de la factura no coincide con el total del XML. Usa el botón "¿Por qué no cuadra?" junto a los totales para ver el detalle.'
      );
    }
    axios
      .post(
        "ordenesdecompra/recibirFactura",
        {
          ...values,
          // Es un dia, no un instante: el backend lo ancla al mediodia UTC
          fechaRecepcion: values.fechaRecepcion
            ? moment(values.fechaRecepcion).format("YYYY-MM-DD")
            : undefined,
          editarOCUnicamentePrecios: this.state.editarOCUnicamentePrecios,
          insumos: arrayInsumosFactura,
          empresaId: this.props.empresaId,
          ordenDeCompraId: this.state.id,
          usoDeCfdiId: this.state.xmlCfdi?.usoDeCfdiId,
          formaDePagoId: this.state.xmlCfdi?.formaDePagoId,
          metodoPago: this.state.xmlCfdi?.metodoPago,
          total: round2Decimals(total),
          subtotal: round2Decimals(subtotal),
          cuentasProveedor: round2Decimals(cuentasProveedor),
          totalPagar: round2Decimals(total - cuentasProveedor),
          crearAjusteAlCosto: this.state.crearAjusteAlCosto,
          editarOC: this.state.editarOC,
          arrayImpuestos,
          arrayRetenciones,
          entregasRelacionadas: this.construirEntregasRelacionadas(arrayInsumosFactura),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha recibido una factura de la orden de compra: " +
            res.data.codigo
          );
          if (res.data.avisoEntregas) message.warn(res.data.avisoEntregas, 8);
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se puede recibir la factura");
        } else {
          message.error("Hubo un error y no se recibio la factura");
        }
      });
  }
  atras() {
    this.props.history.push("/panel/ordenesDeCompra");
  }
  onChangeUUID(value) {
    //Los uuid que no son del SAT (folios internos, capturas a medias) no se revisan
    if (!esUuidSat(value)) {
      if (this.state.uuidDuplicado) {
        this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
      }
      return;
    }
    axios
      .post(
        "facturas/checarUUID",
        { uuid: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.existeUUID === 1) {
          const mensaje =
            res.data.message ||
            "No se puede registrar: la factura ya existe en el sistema";
          this.setState({ uuidDuplicado: true, mensajeUuidDuplicado: mensaje });
          message.error(mensaje);
        } else {
          this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
        }
      });
  }

  // Construye el payload para el modal
  buildConceptosXML = (insumosXml) => {
    return insumosXml.map((it, idx) => ({
      idx,
      insumoId: it.insumoId || null,
      clave: it.clave || "",
      descripcion: it.descripcion || "", // opcional si la traes en buscarRelacion
      cantidad: it.cantidad,
      valorUnitario: it.precioUnitario,
      descuento: it.descuento || 0,
      impuestos: it.impuestos || 0,
    }));
  };

  buildOdcPendientes = (formInsumos) => {
    return formInsumos.map((it, idx) => {
      const insumo = this.state.todasInsumos.find((x) => x._id === it.insumoId);
      // const pendiente = round2Decimals(
      //   (it.cantidad || 0) - (it.recibir || 0)
      // );
      const pendiente = round2Decimals(
        (it.cantidad || 0) - (it.recibidoFacturas || 0) - (it.recibir || 0)
      );
      return {
        idx,
        insumoId: it.insumoId,
        descripcion: insumo?.stringBuscar || "",
        pendiente,
        precioODC: it.precioUnitarioAjustado ?? it.precioUnitario ?? 0,
      };
    });
  };

  // Abre el modal con todo listo
  openEmparejarManual({
    insumosXml,
    formInsumos,
    eFile,
    comprobante,
    timbre,
    motivo,
  }) {
    const conceptosXML = this.buildConceptosXML(insumosXml);
    const odcPendientes = this.buildOdcPendientes(formInsumos);

    // Deja el archivo listo en la UI, quita el loading, y abre modal
    this.setState({
      archivosXml: [{ ...(eFile || {}), name: eFile?.name, status: "success" }],
      archivo: eFile,
      loading: false,
      emparejarVisible: true,
      conceptosXML,
      odcPendientes,
      xmlParseBasico: {
        SubTotal: (comprobante?.SubTotal || 0) - (comprobante?.Descuento || 0),
        Total: comprobante?.Total || 0,
        Moneda: comprobante?.Moneda || "",
        TipoCambio: comprobante?.TipoCambio || 1,
        UUID: timbre?.UUID || null,
        Motivo: motivo || null,
      },
    });
  }

  async leerXml(e) {
    this.setState({ loading: true });
    if (e.file.type === "text/xml") {
      var reader = new FileReader();
      reader.onload = async (event) => {
        let insumosSinRegistrar = 0;
        let insumos = [];
        let proveedorId;
        let fechaFactura;
        let uuid;
        let codigoFactura;
        let tipoDeCambio;
        let monedaId;
        const hola = new xmlToJson().parseFromString(event.target.result);
        const comprobante = hola?.attributes;
        const emisor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Emisor"
        )?.attributes;
        const complemento = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Complemento"
        );
        const timbre = complemento.children.find(
          (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
        )?.attributes;
        const receptor = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Receptor"
        )?.attributes;
        const conceptos = hola.children.find(
          (valueXml) => valueXml.name === "cfdi:Conceptos"
        )?.children;

        if (comprobante.TipoDeComprobante !== "I") {
          this.setState({
            archivosXml: [
              {
                ...e.file,
                name: e.file.name,
                status: "success",
              },
            ],
            archivo: e.file,
            loading: false,
          });
          return message.error("El xml no es una factura de ingreso");
        }

        if (
          receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()
        ) {
          if (
            this.state.datosOrdenDeCompra.proveedor.rfc.toLowerCase() !==
            decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
          ) {
            this.setState({
              loading: false,
            });
            return notification.warning({
              message:
                "El proveedor del xml no es el mismo que el de la orden de compra",
            });
          } else {
            proveedorId = this.state.datosOrdenDeCompra.proveedorId;
          }
        } else {
          this.setState({
            archivosXml: [
              {
                ...e.file,
                name: e.file.name,
                status: "success",
              },
            ],
            archivo: e.file,
            loading: false,
          });
          return message.error(
            "El rfc del receptor no es igual al de la empresa"
          );
        }

        avisarRegimenYObjetoImpXml({ receptor, conceptos, empresaId: this.props.empresaId, headersToken: this.props.headersToken });

        const moneda = this.state.todasMonedas?.find(
          (valueTodos) =>
            valueTodos.abreviacion?.toLowerCase() ===
            comprobante.Moneda?.toLowerCase()
        );

        if (moneda) {
          monedaId = moneda._id;
        } else {
          this.setState({ loading: false });
          return message.warning(
            "La moneda del comprobante no coincide con la de la orden de compra"
          );
        }

        if (monedaId !== this.formRef.current.getFieldValue("monedaId")) {
          this.setState({ loading: false });
          return message.warning(
            "La moneda del comprobante no coincide con la de la orden de compra"
          );
        }

        await Promise.all(
          conceptos.map(async (valueConcepto) => {
            const attr = valueConcepto.attributes;
            let totalImpuestos = 0;
            valueConcepto.children
              .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
              ?.children.find(
                (valueTodos) => valueTodos.name === "cfdi:Traslados"
              )
              ?.children.map((valueImpuesto) => {
                const attrImpuestos = valueImpuesto.attributes;
                totalImpuestos += attrImpuestos.Importe;
                return null;
              });
            await axios
              .post(
                "insumos/buscarRelacion",
                {
                  empresaId: this.props.empresaId,
                  proveedorId: proveedorId,
                  descripcion: decodeHTMLEntities(attr.Descripcion),
                  claveProdServ: decodeHTMLEntities(attr.ClaveProdServ),
                  claveUnidad: decodeHTMLEntities(attr.ClaveUnidad),
                  codigo: decodeHTMLEntities(attr.NoIdentificacion),
                },
                {
                  headers: this.props.headersToken,
                }
              )
              .then((res) => {
                if (res.data.status === 404) {
                  insumosSinRegistrar += 1;
                  insumos.push({
                    descripcion: decodeHTMLEntities(attr.Descripcion),
                    clave: decodeHTMLEntities(attr.NoIdentificacion),
                    precioUnitario: Number(attr.ValorUnitario),
                    cantidad: Number(attr.Cantidad),
                    descuentoValor: attr.Descuento
                      ? Number(attr.Descuento / attr.Cantidad)
                      : 0,
                    descuento: attr.Descuento
                      ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000
                      : 0,
                    impuestos: totalImpuestos,
                  });
                } else {
                  insumos.push({
                    descripcion: decodeHTMLEntities(attr.Descripcion),
                    clave: decodeHTMLEntities(attr.NoIdentificacion),
                    insumoId: res.data._id,
                    precioUnitario: Number(attr.ValorUnitario),
                    cantidad: Number(attr.Cantidad),
                    descuentoValor: attr.Descuento
                      ? Number(attr.Descuento / attr.Cantidad)
                      : 0,
                    descuento: attr.Descuento
                      ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000
                      : 0,
                    impuestos: totalImpuestos,
                  });
                }
              });
            return null;
          })
        );

        if (insumosSinRegistrar > 0) {
          notification.warning({
            message: insumosSinRegistrar + " insumos no estan registrados",
          });
          return this.props.history.push("/panel/leerXml", {
            fileName: e.file.name,
            fileData: JSON.stringify(hola),
            origin: "/panel/recibirFacturaOrdenDeCompra",
            state: { id: this.state.id },
          });
        }

        //Checar si todos los insumos estan en la orden de compra

        await this.emparejarInsumosXmlConOC(insumos, comprobante, timbre, e.file, e.file.name);

        const pagosXML = {
          SubTotal: comprobante.SubTotal - (comprobante.Descuento || 0),
          Total: comprobante.Total,
        };

        fechaFactura = moment(comprobante.Fecha);
        codigoFactura =
          (comprobante.Serie ? comprobante.Serie : "") +
          " - " +
          (comprobante.Folio ? comprobante.Folio : "");
        uuid = timbre.UUID;
        tipoDeCambio = comprobante.TipoCambio || 1;

        if (uuid) {
          this.onChangeUUID(uuid);
        }

        await this.formRef.current.setFieldsValue({
          fechaFactura,
          codigoFactura,
          uuid,
          tipoDeCambio,
        });

        this.setState({
          xmlFile: true,
          xmltotales: pagosXML,
          // Aqui los renglones vienen de la orden de compra y no conservan la identidad del
          // concepto, asi que el unico puente entre los dos lados es el insumoId que acaba de
          // resolver buscarRelacion.
          xmlDiagnostico: leerCfdiParaDiagnostico(hola, { insumosDelXml: insumos }),
          xmlCfdi: (() => {
            const rawUso = receptor?.UsoCFDI || null;
            const rawFP = comprobante?.FormaPago || null;
            const metodo = comprobante?.MetodoPago === "PUE" ? 1 : comprobante?.MetodoPago === "PPD" ? 2 : null;
            return {
              usoCFDI: rawUso,
              formaDePago: rawFP,
              metodoPago: metodo,
              usoDeCfdiId: this.state.todasUsosDeCFDI?.find((v) => v.c_UsoCFDI === rawUso)?._id || null,
              formaDePagoId: rawFP
                ? this.state.todasFormasDePago?.find((v) =>
                    Number(v.c_FormaPago) === Number(rawFP)
                  )?._id || null
                : null,
            };
          })(),
          archivosXml: [
            {
              ...e.file,
              name: e.file.name,
              status: "success",
            },
          ],
          archivo: e.file,
          loading: false,
        });
      };

      reader.readAsText(e.file);
    } else {
      message.error("El archivo debe ser un archivo de xml");
      this.setState({ loading: false });
    }
  }

  async leerXmlData(state) {
    await this.consultarTodo();
    this.setState({ loading: true });
    let insumosSinRegistrar = 0;
    let insumos = [];
    let proveedorId;
    let fechaFactura;
    let uuid;
    let codigoFactura;
    let tipoDeCambio;
    let monedaId;
    const hola = JSON.parse(state.fileData);
    const comprobante = hola?.attributes;
    const emisor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Emisor"
    )?.attributes;
    const complemento = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Complemento"
    );
    const timbre = complemento.children.find(
      (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
    )?.attributes;
    const receptor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Receptor"
    )?.attributes;
    const conceptos = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Conceptos"
    )?.children;

    if (comprobante.TipoDeComprobante !== "I") {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false,
      });
      return message.error("El xml no es una factura de ingreso");
    }

    if (receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()) {
      if (
        this.state.datosOrdenDeCompra.proveedor.rfc.toLowerCase() !==
        decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
      ) {
        this.setState({
          loading: false,
        });
        return notification.warning({
          message:
            "El proveedor del xml no es el mismo que el de la orden de compra",
        });
      } else {
        proveedorId = this.state.datosOrdenDeCompra.proveedorId;
      }
    } else {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false,
      });
      return message.error("El rfc del receptor no es igual al de la empresa");
    }

    avisarRegimenYObjetoImpXml({ receptor, conceptos, empresaId: this.props.empresaId, headersToken: this.props.headersToken });

    const moneda = this.state.todasMonedas?.find(
      (valueTodos) =>
        valueTodos.abreviacion?.toLowerCase() ===
        comprobante.Moneda?.toLowerCase()
    );

    if (moneda) {
      monedaId = moneda._id;
    } else {
      this.setState({ loading: false });
      return message.warning(
        "La moneda del comprobante no coincide con la de la orden de compra"
      );
    }

    if (monedaId !== this.formRef.current.getFieldValue("monedaId")) {
      this.setState({ loading: false });
      return message.warning(
        "La moneda del comprobante no coincide con la de la orden de compra"
      );
    }

    await Promise.all(
      conceptos.map(async (valueConcepto) => {
        const attr = valueConcepto.attributes;
        let totalImpuestos = 0;
        valueConcepto.children
          .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
          ?.children.find((valueTodos) => valueTodos.name === "cfdi:Traslados")
          ?.children.map((valueImpuesto) => {
            const attrImpuestos = valueImpuesto.attributes;
            totalImpuestos += attrImpuestos.Importe;
            return null;
          });
        await axios
          .post(
            "insumos/buscarRelacion",
            {
              empresaId: this.props.empresaId,
              proveedorId: proveedorId,
              descripcion: decodeHTMLEntities(attr.Descripcion),
              claveProdServ: decodeHTMLEntities(attr.ClaveProdServ),
              claveUnidad: decodeHTMLEntities(attr.ClaveUnidad),
              codigo: decodeHTMLEntities(attr.NoIdentificacion),
            },
            {
              headers: this.props.headersToken,
            }
          )
          .then((res) => {
            if (res.data.status === 404) {
              insumosSinRegistrar += 1;
              insumos.push({
                descripcion: decodeHTMLEntities(attr.Descripcion),
                clave: decodeHTMLEntities(attr.NoIdentificacion),
                precioUnitario: Number(attr.ValorUnitario),
                cantidad: Number(attr.Cantidad),
                descuentoValor: attr.Descuento
                  ? Number(attr.Descuento / attr.Cantidad)
                  : 0,
                descuento: attr.Descuento
                  ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000
                  : 0,
                impuestos: totalImpuestos,
              });
            } else {
              insumos.push({
                descripcion: decodeHTMLEntities(attr.Descripcion),
                clave: decodeHTMLEntities(attr.NoIdentificacion),
                insumoId: res.data._id,
                precioUnitario: Number(attr.ValorUnitario),
                cantidad: Number(attr.Cantidad),
                descuentoValor: attr.Descuento
                  ? Number(attr.Descuento / attr.Cantidad)
                  : 0,
                descuento: attr.Descuento
                  ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000
                  : 0,
                impuestos: totalImpuestos,
              });
            }
          });
        return null;
      })
    );

    if (insumosSinRegistrar > 0) {
      notification.warning({
        message: insumosSinRegistrar + " insumos no estan registrados",
      });
      return this.props.history.push("/panel/leerXml", {
        fileName: state.fileName,
        fileData: JSON.stringify(hola),
        origin: "/panel/recibirFacturaOrdenDeCompra",
        state: { id: this.state.id },
      });
    }

    //Checar si todos los insumos estan en la orden de compra

    await this.emparejarInsumosXmlConOC(insumos, comprobante, timbre, state.fileData, state.fileName);

    const pagosXML = {
      SubTotal: comprobante.SubTotal - (comprobante.Descuento || 0),
      Total: comprobante.Total,
    };

    fechaFactura = moment(comprobante.Fecha);
    codigoFactura =
      (comprobante.Serie ? comprobante.Serie : "") +
      " - " +
      (comprobante.Folio ? comprobante.Folio : "");
    uuid = timbre.UUID;
    tipoDeCambio = comprobante.TipoCambio || 1;

    if (uuid) {
      this.onChangeUUID(uuid);
    }

    await this.formRef.current.setFieldsValue({
      fechaFactura,
      codigoFactura,
      uuid,
      tipoDeCambio,
    });

    this.setState({
      xmlFile: true,
      xmltotales: pagosXML,
      xmlDiagnostico: leerCfdiParaDiagnostico(hola, { insumosDelXml: insumos }),
      xmlCfdi: (() => {
        const rawUso = receptor?.UsoCFDI || null;
        const rawFP = comprobante?.FormaPago || null;
        const metodo = comprobante?.MetodoPago === "PUE" ? 1 : comprobante?.MetodoPago === "PPD" ? 2 : null;
        return {
          usoCFDI: rawUso,
          formaDePago: rawFP,
          metodoPago: metodo,
          usoDeCfdiId: this.state.todasUsosDeCFDI?.find((v) => v.c_UsoCFDI === rawUso)?._id || null,
          formaDePagoId: rawFP
            ? this.state.todasFormasDePago?.find((v) =>
                Number(v.c_FormaPago) === Number(rawFP)
              )?._id || null
            : null,
        };
      })(),
      archivosXml: [
        {
          name: state.fileName,
          status: "success",
        },
      ],
      archivo: state.fileData,
      loading: false,
    });
  }

  emparejarInsumosXmlConOC = async (insumos, comprobante, timbre, file, fileName) => {
    let nuevosInsumosRecibir = await this.formRef.current.getFieldValue("insumos");
    const insumosNoEncontrados = [];
    let hayDiferenciasPrecios = false;
    let hayCantidadesExcedidas = false;

    const toleranciaPrecio = 0.01; // Tolerancia para diferencias de precio


    // Crear copia profunda para trabajar
    nuevosInsumosRecibir = nuevosInsumosRecibir.map(i => ({ ...i }));

    for (const insumoXml of insumos) {
      let cantidadRestante = round2Decimals(insumoXml.cantidad);

      // Buscar todas las líneas de este insumo en la OC que tengan cantidad disponible
      const lineasOC = nuevosInsumosRecibir
        .map((item, index) => ({ ...item, indexOriginal: index }))
        .filter((item) => {
          if (item.insumoId.toString() !== insumoXml.insumoId.toString()) {
            return false;
          }
          // const disponible = round2Decimals(
          //   (item.cantidad) - (item.recibir || 0)
          // )
          // const disponible = round2Decimals(
          //   (item.cantidad - item.recibidoFacturas) - (item.recibir || 0)
          // );
          return true;
        });

      // Si no existe el insumo en la OC
      if (lineasOC.length === 0) {
        console.log("Insumo no encontrado en OC:", insumoXml, nuevosInsumosRecibir.map(i => ({ insumoId: i.insumoId })));
        insumosNoEncontrados.push(insumoXml);
        continue;
      }

      // Procesar cada línea de la OC para este insumo
      for (const lineaOC of lineasOC) {
        if (cantidadRestante <= 0) break;

        const indexOC = lineaOC.indexOriginal;
        // const porRecibir = round2Decimals(
        //   lineaOC.cantidad - (lineaOC.recibir || 0)
        // );
        const porRecibir = round2Decimals(
          lineaOC.cantidad - lineaOC.recibidoFacturas - (lineaOC.recibir || 0)
        );

        if (porRecibir <= 0) continue;

        // Calcular precios para comparación
        const precioXmlNeto = (
          insumoXml.precioUnitario - insumoXml.descuentoValor
        );
        const precioOC = (lineaOC.precioUnitarioAjustadoOC);

        // Verificar si los precios coinciden (tolerancia de toleranciaPrecio)
        const preciosCoinciden = Math.abs(precioOC - precioXmlNeto) < toleranciaPrecio;

        // Marcar en azul si los precios no coinciden
        if (!preciosCoinciden) {
          nuevosInsumosRecibir[indexOC].marcarAzul = true;
          hayDiferenciasPrecios = true;
        }

        // Asignar la cantidad a recibir
        const cantidadAsignar = Math.min(cantidadRestante, porRecibir);
        nuevosInsumosRecibir[indexOC].recibir = round2Decimals(
          (nuevosInsumosRecibir[indexOC].recibir || 0) + cantidadAsignar
        );
        nuevosInsumosRecibir[indexOC].cantidadXML = round2Decimals(
          (nuevosInsumosRecibir[indexOC].cantidadXML || 0) + cantidadAsignar
        );
        nuevosInsumosRecibir[indexOC].precioUnitarioXML = round6Decimals(insumoXml.precioUnitario);
        nuevosInsumosRecibir[indexOC].descuentoXML = insumoXml.descuento || 0;

        cantidadRestante = round2Decimals(cantidadRestante - cantidadAsignar);
      }

      // Si sobra cantidad después de recorrer todas las líneas
      if (cantidadRestante > 0) {
        // Buscar la última línea emparejada para marcar el exceso
        const ultimaLineaEmparejada = lineasOC[lineasOC.length - 1];
        if (ultimaLineaEmparejada) {
          const indexOC = ultimaLineaEmparejada.indexOriginal;
          nuevosInsumosRecibir[indexOC].marcarRojo = true;
          nuevosInsumosRecibir[indexOC].cantidadXML = round2Decimals(
            (nuevosInsumosRecibir[indexOC].cantidadXML || 0) + cantidadRestante
          );
          nuevosInsumosRecibir[indexOC].precioUnitarioXML = round6Decimals(
            insumoXml.precioUnitario
          );
          nuevosInsumosRecibir[indexOC].descuentoXML = insumoXml.descuento || 0;
          hayCantidadesExcedidas = true;
        }
      }
    }

    // Actualizar el formulario
    await this.formRef.current.setFieldsValue({
      insumos: nuevosInsumosRecibir,
    });

    // Actualizar estado y mostrar notificaciones
    this.setState({
      archivosXml: [
        {
          ...file,
          name: fileName,
          status: "success",
        },
      ],
      archivo: file,
      loading: false,
    });

    // Si hay insumos no encontrados, abrir emparejamiento manual
    if (insumosNoEncontrados.length > 0) {
      notification.warning({
        message: "Algunos insumos no coinciden con la orden de compra",
        description: `${insumosNoEncontrados.length} insumo(s) requieren emparejamiento manual`,
      });
      this.openEmparejarManual({
        insumosXml: insumosNoEncontrados,
        formInsumos: nuevosInsumosRecibir,
        eFile: file,
        comprobante,
        timbre,
        motivo: "INSUMO_NO_EN_ODC",
      });
    }

    // Notificar sobre diferencias de precios
    if (hayDiferenciasPrecios) {
      this.setState({ hayDiferenciasPrecios: true });
      notification.warning({
        message: "Los precios de algunos insumos no coinciden con la orden de compra",
        description: "Revise los elementos marcados en azul",
      });
    }

    // Notificar sobre cantidades excedidas
    if (hayCantidadesExcedidas) {
      notification.warning({
        message: "La cantidad de algunos insumos excede la cantidad de la orden de compra",
        description: "Revise los elementos marcados en rojo",
      });
    }
  };

  recibirTodosLosInsumos = () => {
    const form = this.formRef.current;
    if (!form) return;

    const insumos = form.getFieldValue("insumos") || [];

    //Insumos con su 
    const nuevosInsumos = insumos.map((insumo) => {
      const cantidad = Number(insumo.cantidad) || 0;
      const recibido = Number(insumo.recibidoFacturas) || 0;

      const max = cantidad - recibido;

      return {
        ...insumo,
        recibir: max > 0 ? max : 0,
      };
    });

    form.setFieldsValue({ insumos: nuevosInsumos })

    message.success("Se asignaron cantidades a recibir a todos los insumos");
  }

  /*
    Arma el diagnostico con lo que el bloque de totales ya tiene acumulado. Se calcula al abrir el
    modal y no en cada render, porque el FormItem con shouldUpdate se re-renderiza en cada tecla.

    Aqui el renglon viene de la orden de compra: la cantidad esta en `recibir`, el subtotal no se
    guarda en el renglon y el insumo hay que buscarlo en todasInsumos.
  */
  abrirDiagnosticoCuadre(acumulados) {
    const capturado = construirCapturadoDesdeTotales({
      ...acumulados,
      arrayInsumos: this.formRef.current.getFieldValue("insumos"),
      resolverInsumo: (valueRenglon) =>
        this.state.todasInsumos.find((valueIn) => valueIn._id === valueRenglon.insumoId),
      resolverRenglon: (valueRenglon) => {
        const cantidad = valueRenglon.recibir;
        const descuento = valueRenglon.descuento || 0;
        const bruto = round2Decimals(valueRenglon.precioUnitario * cantidad);
        return {
          cantidad,
          descuento,
          precioUnitario: valueRenglon.precioUnitario,
          subtotal: round2Decimals(bruto - round2Decimals(bruto * (descuento / 100))),
        };
      },
      omitirImpuestos: !!this.state.proveedorExtranjero,
      // El catalogo de retenciones del proveedor solo viene completo en todasProveedores; el que
      // trae datosOrdenDeCompra es el resumen para la cabecera.
      proveedor: this.state.todasProveedores?.find(
        (valueP) => valueP._id === this.state.datosOrdenDeCompra?.proveedorId
      ),
      ajusteMax: this.state.ajusteMax,
    });
    this.setState({
      modalDiagnosticoVisible: true,
      diagnostico: diagnosticarCuadreFactura({ xml: this.state.xmlDiagnostico, capturado }),
      ajusteContexto: {
        subtotalVI: acumulados.subtotalVI,
        cuentasProveedorVI: acumulados.cuentasProveedorVI,
        arrayImpuestos: acumulados.arrayImpuestos,
        arrayRetenciones: acumulados.arrayRetenciones,
      },
    });
  }

  ajustarTotalesAutomaticamente({ subtotalVI, cuentasProveedorVI, arrayImpuestos, arrayRetenciones }) {
    const resultado = calcularAjusteAutomaticoFactura({
      subtotalVI,
      cuentasProveedorVI,
      arrayImpuestos,
      arrayRetenciones,
      xmltotales: this.state.xmltotales,
      ajusteMax: this.state.ajusteMax,
    });
    const aplicarAjuste = () => {
      this.formRef.current.setFieldsValue(resultado.ajustes);
      if (resultado.restante !== 0) {
        message.warning(
          "No fue posible cubrir toda la diferencia automáticamente, queda una diferencia de $" +
            Math.abs(resultado.restante).toFixed(2) +
            " por el límite de ajuste configurado."
        );
      }
    };
    if (Math.abs(resultado.diferenciaOriginal) > 0.5) {
      Modal.confirm({
        title: "Diferencia considerable",
        content:
          "La diferencia entre el total del XML y el total capturado es de $" +
          Math.abs(resultado.diferenciaOriginal).toFixed(2) +
          ", lo cual es una diferencia considerable. ¿Desea realizar el ajuste automático de todas formas?",
        okText: "Sí, ajustar",
        cancelText: "Cancelar",
        onOk: aplicarAjuste,
      });
    } else {
      aplicarAjuste();
    }
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            "Recibir Factura sobre Orden de Compra " +
            ((this.state?.datosOrdenDeCompra?.serieOrdenCompra
              ? this.state.datosOrdenDeCompra.serieOrdenCompra + " - "
              : "") +
              this?.state?.datosOrdenDeCompra?.numero)
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <h1>
              Fecha:{" "}
              {moment(this.state.datosOrdenDeCompra?.createdAt).format("LL")}
            </h1>,
            <ButtonItem
              blanco
              type="primary"
              icon={<FileSearchOutlined />}
              onClick={() => this.setState({ seleccionarXmlVisible: true })}
            >
              Seleccionar XML
            </ButtonItem>,
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={this.state.archivosXml}
              customRequest={this.leerXml.bind(this)}
              accept=".xml"
            >
              <ButtonItem cyan type="primary"  icon={<UploadOutlined />}>
                Leer Xml
              </ButtonItem>
            </Upload>,
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading} tip={"Cargando..."} size="large">
            <Form
              ref={this.formRef}
              name="recibirInsumosOrdenDeCompra"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              {this.state.datosOrdenDeCompra && (
                <div style={{ padding: "0 16px", marginTop: 8, marginBottom: 16 }}>
                  <Row>
                    <InfoCard
                      title="PROYECTO"
                      icon={<InfoCircleOutlined />}
                      accentColor="#00BFD6"
                      compact
                      dense
                      sections={[
                        {
                          title: "Información General",
                          icon: <InfoCircleOutlined />,
                          iconColor: "#00BFD6",
                          lg: 12,
                          items: [
                            { label: "Nombre", value: this.state.datosOrdenDeCompra?.proyecto.nombre || "-" },
                            { label: "Descripcion", value: this.state.datosOrdenDeCompra?.proyecto.descripcion || "-" },
                          ],
                        },
                        {
                          title: this.state.datosOrdenDeCompra?.proyecto.calle ? "Dirección de envio" : "Vehículo",
                          icon: this.state.datosOrdenDeCompra?.proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                          iconColor: "#C9DF00",
                          lg: 12,
                          items: this.state.datosOrdenDeCompra?.proyecto.calle
                            ? [
                              { label: "Calle", value: this.state.datosOrdenDeCompra?.proyecto.calle || "-" },
                              { label: "Numero", value: this.state.datosOrdenDeCompra?.proyecto.numeroCalle || "-" },
                            ]
                            : [
                              { label: "Marca", value: this.state.datosOrdenDeCompra?.proyecto.marca || "-" },
                              { label: "Modelo", value: this.state.datosOrdenDeCompra?.proyecto.modelo || "-" },
                              { label: "Placas", value: this.state.datosOrdenDeCompra?.proyecto.placas || "-" },
                            ],
                        },
                      ]}
                      splitWith={{
                        title: "PROVEEDOR",
                        icon: <ShopOutlined />,
                        accentColor: "#FF6A0D",
                        compact: true,
                        dense: true,
                        sections: [
                          {
                            title: "Datos del Proveedor",
                            icon: <ShopOutlined />,
                            iconColor: "#FF6A0D",
                            lg: 12,
                            items: [
                              {
                                label: "Nombre",
                                value: (this.state.datosOrdenDeCompra?.proveedor.nombre
                                  ? this.state.datosOrdenDeCompra?.proveedor.nombre +
                                  " " +
                                  this.state.datosOrdenDeCompra?.proveedor
                                    .apellidoPaterno +
                                  " " +
                                  this.state.datosOrdenDeCompra?.proveedor.apellidoMaterno
                                  : this.state.datosOrdenDeCompra?.proveedor.razonSocial) || "-",
                              },
                              { label: "Rfc", value: this.state.datosOrdenDeCompra?.proveedor.rfc || "-" },
                              { label: "Correo", value: this.state.datosOrdenDeCompra?.proveedor.correo || "-" },
                              { label: "Telefono", value: this.state.datosOrdenDeCompra?.proveedor.telefono || "-" },
                              { label: "Celular", value: this.state.datosOrdenDeCompra?.proveedor.celular || "-" },
                            ],
                          },
                          {
                            title: "Contacto",
                            icon: <ContactsOutlined />,
                            iconColor: "#00BFD6",
                            lg: 12,
                            items: [
                              { label: "Contacto", value: this.state.datosOrdenDeCompra?.proveedor.nombreContacto || "-" },
                              { label: "Tel. Contacto", value: this.state.datosOrdenDeCompra?.proveedor.telefonoContacto || "-" },
                              { label: "Correo Contacto", value: this.state.datosOrdenDeCompra?.proveedor.correoContacto || "-" },
                              { label: "Dias de crédito", value: this.state.datosOrdenDeCompra?.proveedor.diasCredito || "-" },
                            ],
                          },
                        ],
                      }}
                    />
                  </Row>
                </div>
              )}
              <GeneralFormLayout
                isMobile={isMobile}
                cards={[
                  {
                    title: "Factura",
                    lg: 8,
                    xl: 8,
                    content: (
                      <>
                        <FormItem
                          name="codigoFactura"
                          label="Codigo Factura"
                          margin
                          pattern
                        >
                          <InputItem placeholder="Codigo Factura" />
                        </FormItem>
                        <FormItem
                          name="descripcion"
                          label="Descripcion"
                          margin
                          pattern
                        >
                          <InputItem placeholder="Descripcion" />
                        </FormItem>
                        <FormItem
                          name="uuid"
                          label="UUID"
                          margin
                          pattern
                          required={!this.state.proveedorExtranjero}
                        >
                          <InputItem
                            onChange={(e) => this.onChangeUUID(e.target.value)}
                            placeholder="UUID"
                          />
                        </FormItem>
                      </>
                    ),
                  },
                  {
                    title: "Fechas y Crédito",
                    lg: 9,
                    xl: 9,
                    content: (
                      <>
                        <FormItem
                          label="Fecha de Factura"
                          name="fechaFactura"
                          required
                          margin
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }} 

                        >
                          <DatePickerItem
                            placeholder="Fecha de Factura"
                            allowClear={false}
                            onChange={(value) => {
                              // Con el vencimiento desde la recepcion, la fecha de factura ya no lo mueve
                              if (this.props.vencimientoDesdeRecepcionFactura) return;
                              const fechaFactura = moment(value);
                              const diasCredito =
                                this.formRef.current.getFieldValue("diasCredito");
                              this.formRef.current.setFieldsValue({
                                fechaPago: fechaFactura.add(diasCredito, "days"),
                              });
                            }}
                          />
                        </FormItem>
                        {this.props.vencimientoDesdeRecepcionFactura && (
                          <FormItem
                            label="Fecha de Recepción"
                            name="fechaRecepcion"
                            required
                            margin
                            initialValue={moment()}
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <DatePickerItem
                              placeholder="Fecha de Recepción"
                              allowClear={false}
                              onChange={(value) => {
                                const diasCredito =
                                  this.formRef.current.getFieldValue("diasCredito");
                                this.formRef.current.setFieldsValue({
                                  fechaPago: moment(value).add(diasCredito, "days"),
                                });
                              }}
                            />
                          </FormItem>
                        )}
                        <FormItem
                          label="Dias de credito"
                          name="diasCredito"
                          required
                          numberCero
                          margin
                           labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <InputNumberItem
                            placeholder="Dias de Credito"
                            onChange={(value) => {
                              this.formRef.current.setFieldsValue({
                                fechaPago: this.fechaBaseVencimiento().add(value, "days"),
                              });
                            }}
                          />
                        </FormItem>
                        <FormItem
                          label="Fecha probable Pago"
                          name="fechaPago"
                          required
                          margin
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }} 
                        >
                          <DatePickerItem
                            placeholder="Fecha probable Pago"
                            allowClear={false}
                            onChange={(value) => {
                              let fecha = value;
                              let diferencia = fecha.diff(this.fechaBaseVencimiento(), "days") + 1;
                              this.formRef.current.setFieldsValue({
                                diasCredito: diferencia,
                              });
                            }}
                          />
                        </FormItem>
                      </>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 7,
                    xl: 7,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem disabled placeholder="Moneda">
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem
                          noStyle
                          shouldUpdate={(prev, curr) =>
                            prev.monedaId !== curr.monedaId
                          }
                        >
                          {({ getFieldValue }) => {
                            const monedaId = getFieldValue("monedaId");

                            return (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem
                                  disabled={monedaId === "60c7e4396465ad440c41c15a"}
                                  dinero
                                  placeholder="T. Cambio"
                                />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                  {
                    lg: 24,
                    xl: 24,
                    style: { background: "transparent", boxShadow: "none", padding: 0, marginBottom: 8 },
                    bodyStyle: { padding: 0 },
                    content: (() => {
                      const { ocUsoDeCfdi, ocFormaDePago, ocMetodoPago, xmlCfdi, xmlFile, todasUsosDeCFDI, todasFormasDePago } = this.state;
                      const metodoPagoLabel = (v) => v === 1 ? "PUE - Pago en Una sola Exhibición" : v === 2 ? "PPD - Pago en Parcialidades o Diferido" : "—";

                      const xmlUsoCFDIObj = xmlCfdi?.usoCFDI
                        ? todasUsosDeCFDI?.find((v) => v.c_UsoCFDI === xmlCfdi.usoCFDI)
                        : null;
                      const xmlFormaPagoObj = xmlCfdi?.formaDePago
                        ? todasFormasDePago?.find((v) => Number(v.c_FormaPago) === Number(xmlCfdi.formaDePago))
                        : null;

                      const campos = [
                        {
                          label: "Uso de CFDI",
                          ocValor: ocUsoDeCfdi ? `${ocUsoDeCfdi.c_UsoCFDI} - ${ocUsoDeCfdi.descripcion}` : "—",
                          xmlValor: xmlCfdi?.usoCFDI
                            ? xmlUsoCFDIObj
                              ? `${xmlUsoCFDIObj.c_UsoCFDI} - ${xmlUsoCFDIObj.descripcion}`
                              : xmlCfdi.usoCFDI
                            : "—",
                          match: xmlFile && xmlCfdi ? ocUsoDeCfdi?.c_UsoCFDI === xmlCfdi.usoCFDI : null,
                        },
                        {
                          label: "Forma de Pago",
                          ocValor: ocFormaDePago ? `${ocFormaDePago.c_FormaPago} - ${ocFormaDePago.descripcion}` : "—",
                          xmlValor: xmlCfdi?.formaDePago
                            ? xmlFormaPagoObj
                              ? `${xmlFormaPagoObj.c_FormaPago} - ${xmlFormaPagoObj.descripcion}`
                              : xmlCfdi.formaDePago
                            : "—",
                          match: xmlFile && xmlCfdi ? Number(ocFormaDePago?.c_FormaPago) === Number(xmlCfdi.formaDePago) : null,
                        },
                        {
                          label: "Método de Pago",
                          ocValor: metodoPagoLabel(ocMetodoPago),
                          xmlValor: metodoPagoLabel(xmlCfdi?.metodoPago),
                          match: xmlFile && xmlCfdi ? ocMetodoPago === xmlCfdi.metodoPago : null,
                        },
                      ];

                      const spans = [8, 9, 7]; // distribución lg de las mini cards (suman 24; la de en medio más ancha)
                      return (
                        <Row gutter={[10, 10]}>
                          {campos.map(({ label, ocValor, xmlValor, match }, i) => {
                            const sinXml = match === null;
                            const accent = match ? "#52c41a" : "#ff4d4f";
                            //const bg = match ? "#f6ffed6e" : "#fff2f06e";
                            const borderCol = match ? "#b7eb8f" : "#ffccc7";
                            const containerProps = sinXml
                              ? { className: "card-punteada", style: { margin: 0, padding: "8px 12px", height: "100%" } }
                              : {
                                  style: {
                                    position: "relative",
                                    borderRadius: 8,
                                    border: `1px solid ${borderCol}`,
                                    //background: bg,
                                    padding: "8px 12px 8px 14px",
                                    overflow: "hidden",
                                    height: "100%",
                                  },
                                };
                            return (
                              <Col key={label} xs={24} sm={24} md={12} lg={spans[i]}>
                                <div {...containerProps}>
                                {!sinXml && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      bottom: 0,
                                      width: 3,
                                      background: accent,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 6,
                                    marginBottom: 6,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 700,
                                      color: "#434343",
                                      textTransform: "uppercase",
                                      letterSpacing: 0.5,
                                    }}
                                  >
                                    {label}
                                  </span>
                                  {match !== null && (
                                    <Tag
                                      color={match ? "success" : "error"}
                                      style={{
                                        margin: 0,
                                        fontWeight: 700,
                                        fontSize: 11.5,
                                        lineHeight: "20px",
                                        padding: "0 11px",
                                        borderRadius: 14,
                                        border: `1px solid ${accent}`,
                                        boxShadow: `0 1px 3px ${match ? "rgba(82,196,26,0.25)" : "rgba(255,77,79,0.25)"}`,
                                        letterSpacing: 0.3,
                                      }}
                                    >
                                      {match ? "✓ Coincide" : "✗ No coincide"}
                                    </Tag>
                                  )}
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                  <div style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
                                    <span
                                      style={{
                                        fontSize: 9,
                                        fontWeight: 700,
                                        color: "#335482",
                                        background: "#fff",
                                        borderRadius: 5,
                                        padding: "0px 5px",
                                        letterSpacing: 0.5,
                                        flexShrink: 0,
                                      }}
                                    >
                                      OC
                                    </span>
                                    <span style={{ fontSize: 12, color: "#262626", lineHeight: 1.3 }}>{ocValor}</span>
                                  </div>
                                  {xmlFile && xmlCfdi && (
                                    <div style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
                                      <span
                                        style={{
                                          fontSize: 9,
                                          fontWeight: 700,
                                          color: "#408233",
                                          background: "#fff",
                                          borderRadius: 5,
                                          padding: "0px 5px",
                                          letterSpacing: 0.5,
                                          flexShrink: 0,
                                        }}
                                      >
                                        XML
                                      </span>
                                      <span style={{ fontSize: 12, color: "#262626", lineHeight: 1.3 }}>{xmlValor}</span>
                                    </div>
                                  )}
                                </div>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      );
                    })(),
                  },
                ]}
                tabsConfig={{
                  isMobile,
                  formInstance: this.formRef,
                  tableClassName: "tabla-insumos-venta tabla-recibir-factura-fija",
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      renderHeader: () => (
                        <Space>
                          <ButtonItem
                            type="primary"
                            blanco
                            htmlType="button"
                            onClick={() => this.abrirRelacionarEntregas()}
                          >
                            Relacionar entregas
                          </ButtonItem>
                          {Object.keys(this.state.entregasSeleccionadas).length > 0 && (
                            <Tag color="green">
                              {Object.keys(this.state.entregasSeleccionadas).length}{" "}
                              renglones ligados
                            </Tag>
                          )}
                          <Typography.Text
                            style={{ fontSize: "12px", color: "#888" }}
                          >
                            Mostrar detalles
                          </Typography.Text>
                          <Switch
                            size="small"
                            checked={this.state.mostrarDetalles}
                            onChange={(checked) =>
                              this.setState({ mostrarDetalles: checked })
                            }
                          />
                        </Space>
                      ),
                      columns: [
                        { title: "#", width: "4%" },
                        { title: "Insumo", width: "23%" },
                        { title: "Unidad", width: "6%" },
                        { title: "PU", width: "9%" },
                        ...(this.props.escuela ? [{ title: "Desc. Prov.", width: "7%" }] : []),
                        { title: this.props.escuela ? "Desc. Adic." : "Des.", width: "9%" },
                        {
                          title: (
                            <>
                              {
                                this.state.hayDiferenciasPrecios ?
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      padding: "0 8px",
                                      background: "transparent",
                                      border: "none",
                                      flex: "0 0 auto",
                                    }}
                                  >
                                    <Tooltip mouseEnterDelay={1.1} title="Cambiar precios de la OC a los datos del XML.">
                                      <ArrowLeftOutlined
                                        style={{
                                          color: "#1890ff",
                                          fontSize: 14,
                                        }}
                                        onClick={() => {
                                          const insumos = this.formRef.current.getFieldValue("insumos");

                                          const nuevosInsumos = insumos.map((insumo) => {
                                            if (insumo.marcarAzul) {
                                              return {
                                                ...insumo,
                                                precioUnitario: insumo.precioUnitarioXML,
                                                descuento: insumo.descuentoXML,
                                                // Complemento Escuela: el % del XML se parte en Desc. Prov. + adicional.
                                                ...(this.props.escuela
                                                  ? descomponerDescuento(insumo.descuentoXML, insumo.descuentoBase)
                                                  : {}),
                                                marcarAzul: false,
                                              };
                                            } else {
                                              return insumo;
                                            }
                                          });

                                          this.formRef.current.setFieldsValue({
                                            insumos: nuevosInsumos,
                                          });

                                          this.setState({ hayDiferenciasPrecios: false })
                                        }}
                                      />
                                    </Tooltip>
                                  </span>
                                  : null
                              }
                              PU Xml
                            </>
                          ),
                          width: "9%",
                        },
                        { title: "Des. Xml", width: "9%" },
                        { title: "Cant. Xml", width: "9%" },
                        { title: "Cant. Pedida", width: "9%" },
                        { title: "Cant. ya Facturada", width: "9%" },
                        {
                          title: (
                            <>
                              Cant. a Facturar
                              <Tooltip title='Recibir todos los insumos.'>
                                <CalculatorOutlined onClick={() => this.recibirTodosLosInsumos()} style={{ marginLeft: '5px', color: 'green' }} />
                              </Tooltip>
                            </>
                          ),
                          width: "9%",
                        },
                      ],
                      renderRow: ({ key, name, fieldKey, restField, arrayKey }) => (
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const insumos = getFieldValue("insumos");
                            const rowClass = insumos[key]?.marcarRojo ? "row-rojo" : insumos[key]?.marcarAzul
                              ? "row-azul"
                              : "";
                            let cantidad =
                              this.state.datosOrdenDeCompra.insumos[fieldKey]
                                .cantidad;
                            let recibido =
                              this.state.datosOrdenDeCompra.insumos[fieldKey]
                                .recibidoFacturas;
                            const insumoMaestro = resolverInsumoMaestroFrontend(
                              insumos[key]?.insumoId,
                              this.state.todasInsumos
                            );
                            // max real (con tolerancia) para la validación del Form; el placeholder
                            // muestra solo lo pedido, la tolerancia se comunica con color + tooltip
                            const max = round10Decimals(
                              calcularTopeConTolerancia(cantidad, insumoMaestro) - (recibido || 0)
                            );
                            const maxPedido = round10Decimals(cantidad - (recibido || 0));
                            const tieneTolerancia = !!insumoMaestro?.toleranciaRecepcion;
                            const excedenteTolerado = round10Decimals(max - maxPedido);
                            return (
                              <React.Fragment key={fieldKey}>
                                <tr className={rowClass}>
                                  <td className="td-border">
                                    <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                      {arrayKey + 1}
                                    </div>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "insumoId"]}
                                      fieldKey={[fieldKey, "insumoId"]}
                                      required
                                      noStyle
                                    >
                                      <SelectItem
                                        sinBorde
                                        autoFocus
                                        style={{ width: "100%" }}
                                        placeholder="Insumo"
                                        disabled
                                      >
                                        {this.state.objetoInsumos}
                                      </SelectItem>
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    {(() => {
                                      const unidad = insumoMaestro?.unidad;
                                      const unidadTexto = typeof unidad === "object" && unidad !== null
                                        ? (unidad.nombre || unidad.descripcion || "-")
                                        : (unidad || "-");
                                      return (
                                        <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                          {unidadTexto}
                                        </div>
                                      );
                                    })()}
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "precioUnitario"]}
                                      fieldKey={[fieldKey, "precioUnitario"]}
                                      noStyle
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder="Precio Unitario"
                                        dinero
                                      />
                                    </FormItem>
                                  </td>
                                  {this.props.escuela && (
                                    <td className="td-border">
                                      <FormItem
                                        {...restField}
                                        name={[name, "descuentoBase"]}
                                        numberCero
                                        noStyle
                                        initialValue={0}
                                      >
                                        <InputNumberItem
                                          sinBorde
                                          placeholder="Desc. Prov."
                                          porcentaje
                                          max={100}
                                          onChange={() => this.onChangeDescuentoEscuela(name)}
                                        />
                                      </FormItem>
                                    </td>
                                  )}
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, this.props.escuela ? "descuentoAdicional" : "descuento"]}
                                      required
                                      numberCero
                                      noStyle
                                      initialValue={0}
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder={this.props.escuela ? "Desc. Adic." : "Descuento"}
                                        porcentaje
                                        max={100}
                                        onChange={
                                          this.props.escuela
                                            ? () => this.onChangeDescuentoEscuela(name)
                                            : undefined
                                        }
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    {insumos[key]?.marcarAzul ? (
                                      <Input.Group compact style={{ display: "flex", width: "100%" }}>
                                        <span
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            padding: "0 8px",
                                            background: "transparent",
                                            border: "none",
                                            flex: "0 0 auto",
                                          }}
                                        >
                                          <Tooltip mouseEnterDelay={1.1} title="Cambiar el precio Unitario de la OC.">
                                            <ArrowLeftOutlined
                                              style={{
                                                color: "#1890ff",
                                                fontSize: 14,
                                              }}
                                              onClick={() => {
                                                insumos[key].precioUnitario =
                                                  insumos[key].precioUnitarioXML;
                                                insumos[key].descuento =
                                                  insumos[key].descuentoXML;
                                                // Complemento Escuela: el % del XML se parte en Desc. Prov. + adicional.
                                                if (this.props.escuela) {
                                                  Object.assign(
                                                    insumos[key],
                                                    descomponerDescuento(insumos[key].descuentoXML, insumos[key].descuentoBase)
                                                  );
                                                }
                                                insumos[key].marcarAzul = false;
                                                this.formRef.current.setFieldsValue({
                                                  insumos: insumos,
                                                });
                                                const hayDiferenciasPrecios = insumos.some((insumo) => insumo.marcarAzul);
                                                this.setState({ hayDiferenciasPrecios: hayDiferenciasPrecios })
                                              }}
                                            />
                                          </Tooltip>
                                        </span>

                                        <div style={{ flex: 1, minWidth: 0 }}>
                                          <FormItem
                                            {...restField}
                                            name={[name, "precioUnitarioXML"]}
                                            fieldKey={[fieldKey, "precioUnitarioXML"]}
                                            noStyle
                                          >
                                            <InputNumberItem
                                              sinBorde
                                              placeholder="Precio Unitario Xml"
                                              disabled
                                              dineroDisabled
                                              style={{ width: "100%" }}
                                            />
                                          </FormItem>
                                        </div>
                                      </Input.Group>
                                    ) : (
                                      <FormItem
                                        {...restField}
                                        name={[name, "precioUnitarioXML"]}
                                        fieldKey={[fieldKey, "precioUnitarioXML"]}
                                        noStyle
                                      >
                                        <InputNumberItem
                                          sinBorde
                                          placeholder="Precio Unitario Xml"
                                          disabled
                                          dineroDisabled
                                        />
                                      </FormItem>
                                    )}
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "descuentoXML"]}
                                      fieldKey={[fieldKey, "descuentoXML"]}
                                      noStyle
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder="Descuento Xml"
                                        porcentaje
                                        disabled
                                        max={100}
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "cantidadXML"]}
                                      fieldKey={[fieldKey, "cantidadXML"]}
                                      noStyle
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder="Cantidad Xml"
                                        disabled
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "cantidad"]}
                                      fieldKey={[fieldKey, "cantidad"]}
                                      required
                                      number
                                      noStyle
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder="Cantidad Pedida"
                                        disabled
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "recibidoFacturas"]}
                                      fieldKey={[fieldKey, "recibidoFacturas"]}
                                      required
                                      numberCero
                                      noStyle
                                      initialValue={0}
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder="Cantidad ya Facturada"
                                        disabled
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    {/* El Tooltip va POR FUERA del FormItem: si queda en medio,
                                        antd inyecta value/onChange en el Tooltip y nunca llegan
                                        al input, por lo que lo tecleado no se registra en el form. */}
                                    <Tooltip
                                      title={
                                        tieneTolerancia
                                          ? `Puedes recibir hasta ${excedenteTolerado} ${insumoMaestro?.unidad || ""} de más de lo pedido (tolerancia configurada en el insumo).`
                                          : null
                                      }
                                    >
                                      {/* Tooltip envuelve en un span que no hereda el 100% de ancho;
                                          este div lo fuerza para que el input siga llenando la celda. */}
                                      <div style={{ width: "100%" }}>
                                        <FormItem
                                          {...restField}
                                          name={[name, "recibir"]}
                                          fieldKey={[fieldKey, "recibir"]}
                                          numberCero
                                          noStyle
                                          max={max}
                                          type="number"
                                        >
                                          <InputNumberItem
                                            sinBorde
                                            placeholder={"Max: " + maxPedido}
                                            style={tieneTolerancia ? estiloInputConTolerancia : undefined}
                                          />
                                        </FormItem>
                                      </div>
                                    </Tooltip>
                                  </td>
                                </tr>
                                {this.state.mostrarDetalles && (
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(
                                      prevValues,
                                      currentValues
                                    ) => {
                                      const prev =
                                        prevValues.insumos?.[fieldKey];
                                      const curr =
                                        currentValues.insumos?.[fieldKey];
                                      return (
                                        prev?.recibir !== curr?.recibir ||
                                        prev?.insumoId !== curr?.insumoId ||
                                        prev?.precioUnitario !== curr?.precioUnitario
                                      );
                                    }}
                                  >
                                    {({ getFieldValue }) => {
                                      const insumos = getFieldValue("insumos");
                                      const insumoData = insumos?.[fieldKey];

                                      const cantidadActual =
                                        insumoData?.recibir;

                                      const insumoId = insumoData?.insumoId;
                                      const costo = insumoData?.precioUnitario;
                                      let insumoCompleto = null;
                                      if (insumoId && this.state.todasInsumos) {
                                        insumoCompleto =
                                          this.state.todasInsumos.find(
                                            (valueInsumos) =>
                                              valueInsumos._id === insumoId
                                          );
                                      }

                                      if (!insumoCompleto) {
                                        return null;
                                      }

                                      return (
                                        <InsumoDetalleRow
                                          insumo={insumoCompleto}
                                          cantidad={cantidadActual}
                                          costo={costo}
                                          colSpans={{
                                            details: 8,
                                            projection: 3,
                                            filler: this.props.escuela ? 1 : 0,
                                          }}
                                          onCloseModal={() => {
                                            this.consultarTodo();
                                          }}
                                        />
                                      );
                                    }}
                                  </FormItem>
                                )}
                              </React.Fragment>
                            );
                          }}
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={{
                  totalesFacturaMaxWidth: "45%",
                  totalesOrdenCompra: this.state.datosOrdenDeCompra ? (
                    <>
                      <div style={{ textAlign: "center", fontWeight: 700, fontSize: 14, color: "#FF6A0D", padding: "6px 0" }}>
                        Total Orden de Compra
                      </div>
                    <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                      <tbody>
                        <tr>
                          <th className="th-totales" style={{ width: "50%" }}>
                            Subtotal
                          </th>
                          <td
                            className="td-totales-right"
                            style={{ width: "50%" }}
                          >
                            {dineroDisabledMask(
                              this.state.datosOrdenDeCompra.subtotal
                            )}
                          </td>
                        </tr>
                      </tbody>
                      {this.state.datosOrdenDeCompra.arrayImpuestos &&
                        this.state.datosOrdenDeCompra.arrayImpuestos.map(
                          (valueArray) => (
                            <tbody key={valueArray.descripcionFactura}>
                              <tr key={valueArray.descripcionFactura}>
                                <th className="th-totales">
                                  {valueArray.descripcionFactura}
                                </th>
                                <td className="td-totales-right">
                                  {dineroDisabledMask(
                                    valueArray.totalImpuestos
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          )
                        )}
                      <tbody>
                        <tr>
                          <th className="th-totales">Total</th>
                          <td className="td-totales-right">
                            {dineroDisabledMask(
                              this.state.datosOrdenDeCompra.total
                            )}
                          </td>
                        </tr>
                      </tbody>
                      {this.state.datosOrdenDeCompra.arrayRetenciones &&
                        this.state.datosOrdenDeCompra.arrayRetenciones.map(
                          (value) => (
                            <tbody key={value.descripcionFactura}>
                              <tr>
                                <th className="th-totales">
                                  {value.descripcionFactura}
                                </th>
                                <td className="td-totales-right">
                                  {dineroDisabledMask(value.totalRetenciones)}
                                </td>
                              </tr>
                            </tbody>
                          )
                        )}
                      <tbody>
                        <tr>
                          <th className="th-totales">Total a pagar</th>
                          <td className="td-totales-right">
                            {dineroDisabledMask(
                              this.state.datosOrdenDeCompra.totalPagar
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </>
                  ) : null,
                  totalesFactura: this.state.datosOrdenDeCompra ? (
                    <>
                      <div style={{ textAlign: "center", fontWeight: 700, fontSize: 14, color: "#00BFD6", padding: "6px 0" }}>
                        Total Factura Actual
                      </div>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          let arrayInsumos = getFieldValue("insumos");
                          let ajusteSubtotal =
                            getFieldValue("ajusteSubtotal") || 0;
                          if (!arrayInsumos) return null;
                          let proveedorId =
                            this.state.datosOrdenDeCompra.proveedorId;
                          let cuentasProveedor = 0;
                          let subtotal = 0;
                          let subtotalVI = 0;
                          let arrayImpuestos = [];
                          let arrayRetenciones = [];
                          let total = 0;
                          let crearAjusteAlCosto = false;
                          let editarOC = false;
                          arrayInsumos.map((valueInsumo, indexInsumo) => {
                            if (
                              !valueInsumo.recibir ||
                              !valueInsumo.precioUnitario ||
                              valueInsumo.descuento === undefined ||
                              !valueInsumo.insumoId
                            )
                              return null;
                            const insumo = this.state.todasInsumos.find(
                              (valueIn) => valueIn._id === valueInsumo.insumoId
                            );
                            let valuePrecioUnitario =
                              valueInsumo.precioUnitario;
                            let valueCantidad = valueInsumo.recibir;
                            let valueDescuento = valueInsumo.descuento;
                            //1
                            let subtotalInsumoSD = round2Decimals(
                              valuePrecioUnitario * valueCantidad
                            );
                            //2
                            let totalDescuento = round2Decimals(
                              subtotalInsumoSD * (valueDescuento / 100)
                            );
                            //3
                            let subtotalInsumo = round2Decimals(
                              subtotalInsumoSD - totalDescuento
                            );

                            let precioUnitarioAjustado = round6Decimals(valuePrecioUnitario * (1 - (valueDescuento / 100)))
                            if (Math.abs(precioUnitarioAjustado - valueInsumo.precioUnitarioAjustadoOC) > 0.05) {
                              if (this.state.estadoOC === 1 && this.state.estadoFactura === 0) {
                                editarOC = true
                              } else {
                                crearAjusteAlCosto = true
                              }
                            }

                            subtotal += subtotalInsumo;
                            subtotalVI += subtotalInsumo;
                            let totalImpuestosInsumo = 0;
                            if (!this.state.proveedorExtranjero) {
                              insumo.impuestos.map(
                                //4
                                (valueImpuesto) => {
                                  let descripcionFacturaImpuesto =
                                    valueImpuesto.descripcionFactura;
                                  let totalImpuesto;
                                  if (valueImpuesto.tasaCuota === 1) {
                                    totalImpuesto = round6Decimals(
                                      arrayInsumos[indexInsumo].recibir *
                                      precioUnitarioAjustado *
                                      (valueImpuesto.monto / 100)
                                    );
                                  } else if (valueImpuesto.tasaCuota === 2) {
                                    totalImpuesto = round6Decimals(
                                      (arrayInsumos[indexInsumo].recibir *
                                        precioUnitarioAjustado +
                                        totalImpuestosInsumo) *
                                      (valueImpuesto.monto / 100)
                                    );
                                  } else if (valueImpuesto.tasaCuota === 3) {
                                    totalImpuesto = round6Decimals(
                                      arrayInsumos[indexInsumo].recibir *
                                      valueImpuesto.monto
                                    );
                                  } else if (valueImpuesto.tasaCuota === 4) {
                                    totalImpuesto = round6Decimals(
                                      arrayInsumos[indexInsumo].impuestos *
                                      (arrayInsumos[indexInsumo].recibir /
                                        arrayInsumos[indexInsumo].cantidad)
                                    );
                                  } else if (valueImpuesto.tasaCuota === 5) {
                                    totalImpuesto = 0;
                                  }
                                  let totalImpuestosImpuesto = totalImpuesto;
                                  let index = arrayImpuestos.findIndex(
                                    (valueImpuestosAnterios) =>
                                      valueImpuestosAnterios.descripcionFactura ===
                                      descripcionFacturaImpuesto
                                  );
                                  totalImpuestosInsumo +=
                                    totalImpuestosImpuesto;
                                  if (index !== -1) {
                                    let newItem = {
                                      totalImpuestos:
                                        arrayImpuestos[index].totalImpuestos +
                                        totalImpuestosImpuesto,
                                      descripcionFactura:
                                        descripcionFacturaImpuesto,
                                    };
                                    arrayImpuestos.splice(index, 1, newItem);
                                  } else {
                                    arrayImpuestos.push({
                                      totalImpuestos: totalImpuestosImpuesto,
                                      descripcionFactura:
                                        descripcionFacturaImpuesto,
                                    });
                                  }
                                  return null;
                                }
                              );
                            }
                            let totalRetencionesInsumo = 0;
                            if (proveedorId) {
                              const proveedor =
                                this.state.todasProveedores.find(
                                  (valueP) => valueP._id === proveedorId
                                );

                              proveedor.retenciones.map((valueRetencion) => {
                                //7
                                let totalRetencion;
                                let descripcionFacturaRetencion =
                                  valueRetencion.descripcionFactura;
                                if (valueRetencion.tasaCuota === 1) {
                                  totalRetencion = round6Decimals(
                                    arrayInsumos[indexInsumo].recibir *
                                    precioUnitarioAjustado *
                                    (valueRetencion.monto / 100)
                                  );
                                } else if (valueRetencion.tasaCuota === 2) {
                                  totalRetencion = round6Decimals(
                                    (arrayInsumos[indexInsumo].recibir *
                                      precioUnitarioAjustado +
                                      totalRetencionesInsumo) *
                                    (valueRetencion.monto / 100)
                                  );
                                }
                                let index = arrayRetenciones.findIndex(
                                  (valueretencionesAnterios) =>
                                    valueretencionesAnterios.descripcionFactura ===
                                    descripcionFacturaRetencion
                                );
                                totalRetencionesInsumo += totalRetencion;
                                cuentasProveedor += totalRetencion;
                                if (index !== -1) {
                                  let newItem = {
                                    totalRetenciones:
                                      arrayRetenciones[index].totalRetenciones +
                                      totalRetencion,
                                    descripcionFactura:
                                      descripcionFacturaRetencion,
                                  };
                                  arrayRetenciones.splice(index, 1, newItem);
                                } else {
                                  arrayRetenciones.push({
                                    totalRetenciones: totalRetencion,
                                    descripcionFactura:
                                      descripcionFacturaRetencion,
                                  });
                                }
                                return null;
                              });

                              if (!this.state.proveedorExtranjero) {
                                insumo.retenciones.map((valueRetencion) => {
                                  if (
                                    (valueRetencion.aplicaCompra === 1 &&
                                      proveedor.persona === false) ||
                                    (valueRetencion.aplicaCompra === 2 &&
                                      proveedor.persona === true) ||
                                    valueRetencion.aplicaCompra === 3
                                  ) {
                                    //7
                                    let totalRetencion;
                                    let descripcionFacturaRetencion =
                                      valueRetencion.descripcionFactura;
                                    if (valueRetencion.tasaCuota === 1) {
                                      totalRetencion = round6Decimals(
                                        arrayInsumos[indexInsumo].recibir *
                                        precioUnitarioAjustado *
                                        (valueRetencion.monto / 100)
                                      );
                                    } else if (valueRetencion.tasaCuota === 2) {
                                      totalRetencion = round6Decimals(
                                        (arrayInsumos[indexInsumo].recibir *
                                          precioUnitarioAjustado +
                                          totalRetencionesInsumo) *
                                        (valueRetencion.monto / 100)
                                      );
                                    }
                                    let index = arrayRetenciones.findIndex(
                                      (valueretencionesAnterios) =>
                                        valueretencionesAnterios.descripcionFactura ===
                                        descripcionFacturaRetencion
                                    );
                                    totalRetencionesInsumo += totalRetencion;
                                    cuentasProveedor += totalRetencion;
                                    if (index !== -1) {
                                      let newItem = {
                                        totalRetenciones:
                                          arrayRetenciones[index]
                                            .totalRetenciones + totalRetencion,
                                        descripcionFactura:
                                          descripcionFacturaRetencion,
                                      };
                                      arrayRetenciones.splice(
                                        index,
                                        1,
                                        newItem
                                      );
                                    } else {
                                      arrayRetenciones.push({
                                        totalRetenciones: totalRetencion,
                                        descripcionFactura:
                                          descripcionFacturaRetencion,
                                      });
                                    }
                                  }
                                  return null;
                                });
                              }
                            }
                            //5
                            total += subtotalInsumo;
                            return null;
                          });
                          if (crearAjusteAlCosto !== this.state.crearAjusteAlCosto) {
                            this.setState({ crearAjusteAlCosto: crearAjusteAlCosto })
                          }
                          if (editarOC !== this.state.editarOC) {
                            this.setState({ editarOC: editarOC })
                          }
                          let cuentasProveedorVI = cuentasProveedor;
                          subtotal += ajusteSubtotal;
                          total += ajusteSubtotal;
                          arrayImpuestos = arrayImpuestos.map(
                            (valueImpuesto) => {
                              let ajusteImpuesto =
                                getFieldValue(
                                  "ajuste" + valueImpuesto.descripcionFactura
                                ) || 0;
                              total += round2Decimals(
                                valueImpuesto.totalImpuestos + ajusteImpuesto
                              );
                              return {
                                ...valueImpuesto,
                                totalImpuestos: round2Decimals(
                                  valueImpuesto.totalImpuestos + ajusteImpuesto
                                ),
                                totalImpuestosVI: valueImpuesto.totalImpuestos,
                              };
                            }
                          );
                          arrayRetenciones = arrayRetenciones.map(
                            (valueRetencion) => {
                              let ajusteRetencion =
                                getFieldValue(
                                  "ajuste" + valueRetencion.descripcionFactura
                                ) || 0;
                              cuentasProveedor += ajusteRetencion;
                              return {
                                ...valueRetencion,
                                totalRetenciones:
                                  valueRetencion.totalRetenciones +
                                  ajusteRetencion,
                                totalRetencionesVI:
                                  valueRetencion.totalRetenciones,
                              };
                            }
                          );
                          const diferenciaXml = round2Decimals(
                            round2Decimals(Number(this.state.xmltotales?.Total || 0)) -
                              round2Decimals(total - cuentasProveedor)
                          );
                          return (
                            <>
                            {this.state.xmlFile && (
                              <div style={{ textAlign: "right", marginBottom: 8 }}>
                                <Space wrap>
                                  <ButtonItem
                                    {...(diferenciaXml === 0 ? { blanco: true } : { rojo: true })}
                                    icon={<QuestionCircleOutlined />}
                                    onClick={() =>
                                      this.abrirDiagnosticoCuadre({
                                        subtotal,
                                        ajusteSubtotal,
                                        total,
                                        cuentasProveedor,
                                        arrayImpuestos,
                                        arrayRetenciones,
                                        subtotalVI,
                                        cuentasProveedorVI,
                                      })
                                    }
                                  >
                                    {diferenciaXml === 0
                                      ? "Comparar con XML"
                                      : "¿Por qué no cuadra? " + dineroDisabledMask(diferenciaXml)}
                                  </ButtonItem>
                                  <ButtonItem
                                    ambar
                                    icon={<ToolOutlined />}
                                    onClick={() =>
                                      this.ajustarTotalesAutomaticamente({
                                        subtotalVI,
                                        cuentasProveedorVI,
                                        arrayImpuestos,
                                        arrayRetenciones,
                                      })
                                    }
                                  >
                                    Ajustar automáticamente
                                  </ButtonItem>
                                </Space>
                              </div>
                            )}
                            <table
                              className="table totales-table"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                margin: 0,
                              }}
                            >
                              <tbody>
                                <tr>
                                  <th className="td-totales-center" style={{ width: "25%" }}></th>
                                  <td className="td-totales-center" style={{ width: "15%" }}>
                                    <Tag style={{ backgroundColor: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959", fontWeight: 600, padding: "2px 50px", borderRadius: "6px" }}>
                                      Ajuste
                                    </Tag>
                                  </td>
                                  <td className="td-totales-center" style={{ width: "25%" }}></td>
                                  {this.state.xmlFile && (
                                    <td className="td-totales-center" style={{ width: "25%" }}>
                                      <Tag style={{ backgroundColor: "#ecfff2", borderColor: "#85d89f", color: "#008f2d", fontWeight: 600, padding: "2px 60px", borderRadius: "6px" }}>
                                        XML
                                      </Tag>
                                    </td>
                                  )}
                                </tr>
                                <tr>
                                  <th
                                    className="th-totales"
                                    style={{ width: "25%" }}
                                  >
                                    Subtotal
                                  </th>
                                  <td
                                    className="td-totales-right"
                                    style={{ width: "25%" }}
                                  >
                                    <FormItem
                                      name="ajusteSubtotal"
                                      numberNegativo
                                      noStyle
                                      max={this.state.ajusteMax}
                                      min={Math.max(
                                        -this.state.ajusteMax,
                                        -subtotalVI
                                      )}
                                      type="number"
                                      required
                                      initialValue={0}
                                    >
                                      <InputNumberItem
                                        step={0.01}
                                        sinBorde
                                        dinero
                                        precision={2}
                                        placeholder={
                                          "Max: ±" + this.state.ajusteMax
                                        }
                                      />
                                    </FormItem>
                                  </td>
                                  <td
                                    className="td-totales-right"
                                    style={{ width: "25%" }}
                                  >
                                    {dineroDisabledMask(subtotal)}
                                  </td>
                                  {this.state.xmlFile && (
                                    <td
                                      className="td-totales-right"
                                      style={{ width: "25%" }}
                                    >
                                      {dineroDisabledMask(
                                        this.state.xmltotales.SubTotal
                                      )}
                                    </td>
                                  )}
                                </tr>
                              </tbody>
                              {arrayImpuestos.map((valueArray) => (
                                <tbody key={valueArray.descripcionFactura}>
                                  <tr>
                                    <th
                                      className="th-totales"                                    >
                                      {valueArray.descripcionFactura}
                                    </th>
                                    <td
                                      className="td-totales-right"
                                      style={{ width: "25%" }}
                                    >
                                      <FormItem
                                        name={
                                          "ajuste" +
                                          valueArray.descripcionFactura
                                        }
                                        numberNegativo
                                        noStyle
                                        max={this.state.ajusteMax}
                                        min={Math.max(
                                          -this.state.ajusteMax,
                                          -valueArray.totalImpuestosVI
                                        )}
                                        type="number"
                                        required
                                        initialValue={0}
                                        precision={2}
                                      >
                                        <InputNumberItem
                                          step={0.01}
                                          sinBorde
                                          dinero
                                          placeholder={
                                            "Max: ±" + this.state.ajusteMax
                                          }
                                        />
                                      </FormItem>
                                    </td>
                                    <td
                                      className="td-totales-right"                                    >
                                      {dineroDisabledMask(
                                        valueArray.totalImpuestos
                                      )}
                                    </td>
                                    {this.state.xmlFile && (
                                      <td
                                        className="td-totales-right"                                      ></td>
                                    )}
                                  </tr>
                                </tbody>
                              ))}
                              <tbody>
                                <tr>
                                  <th
                                    className="th-totales"                                  >
                                    Total
                                  </th>
                                  <td
                                    className="td-totales-right"
                                    style={{ width: "25%" }}
                                  ></td>
                                  <td
                                    className="td-totales-right"
                                    style={{ width: "25%" }}
                                  >
                                    {dineroDisabledMask(total)}
                                  </td>
                                  {this.state.xmlFile && (
                                    <td
                                      className="td-totales-right"
                                      style={{ width: "25%" }}
                                    ></td>
                                  )}
                                </tr>
                              </tbody>
                              {arrayRetenciones.map((value) => (
                                <tbody key={value.descripcionFactura}>
                                  <tr>
                                    <th
                                      className="th-totales"                                    >
                                      {value.descripcionFactura}
                                    </th>
                                    <td
                                      className="td-totales-right"
                                      style={{ width: "25%" }}
                                    >
                                      <FormItem
                                        name={
                                          "ajuste" + value.descripcionFactura
                                        }
                                        numberNegativo
                                        noStyle
                                        max={this.state.ajusteMax}
                                        min={Math.max(
                                          -this.state.ajusteMax,
                                          -value.totalRetencionesVI
                                        )}
                                        type="number"
                                        required
                                        initialValue={0}
                                        precision={2}
                                      >
                                        <InputNumberItem
                                          step={0.01}
                                          sinBorde
                                          dinero
                                          placeholder={
                                            "Max: ±" + this.state.ajusteMax
                                          }
                                        />
                                      </FormItem>
                                    </td>
                                    <td
                                      className="td-totales-right"                                    >
                                      {dineroDisabledMask(
                                        value.totalRetenciones
                                      )}
                                    </td>
                                    {this.state.xmlFile && (
                                      <td
                                        className="td-totales-right"></td>
                                    )}
                                  </tr>
                                </tbody>
                              ))}
                              <tbody>
                                <tr>
                                  <th
                                    className="th-totales">
                                    Total a pagar
                                  </th>
                                  <td
                                    className="td-totales-right"
                                    style={{ width: "25%" }}
                                  ></td>
                                  <td
                                    className="td-totales-right">
                                    {dineroDisabledMask(
                                      total - cuentasProveedor
                                    )}
                                  </td>
                                  {this.state.xmlFile && (
                                    <td
                                      className="td-totales-right">
                                      {dineroDisabledMask(
                                        this.state?.xmltotales?.Total
                                      )}
                                    </td>
                                  )}
                                </tr>
                              </tbody>
                            </table>
                            </>
                          );
                        }}
                      </FormItem>
                    </>
                  ) : null,
                }}
                actionButtons={
                  (this.state.crearAjusteAlCosto || this.state.editarOC) ? (
                    <>
                      {this.state.editarOC && (
                        <Popconfirm
                          title={"¿Estás seguro de editar unicamente los precios de la orden de compra, la orden de compra quedara pendiente?"}
                          onConfirm={() => {
                            this.setState(
                              { editarOCUnicamentePrecios: true },
                              () => this.formRef.current.formRef.current.submit()
                            );
                          }}
                          okText="Sí"
                          cancelText="No"
                        >
                          <ButtonItem
                            type="primary"
                            blanco
                            disabled={this.state.uuidDuplicado}
                          >
                            Editar Unicamente precios y Recibir
                          </ButtonItem>
                        </Popconfirm>
                      )}
                      <Popconfirm
                        title={this.state.editarOC ? "¿Estás seguro de editar la orden de compra?" : "¿Estás seguro de crear un ajuste al costo por las diferencias en los precios?"}
                        onConfirm={() => {
                          // editarOCUnicamentePrecios lo prende el botón de "Unicamente precios" y nada
                          // lo apagaba: si ese envío fallaba, este botón seguía mandando "solo precios".
                          this.setState(
                            { editarOCUnicamentePrecios: false },
                            () => this.formRef.current.formRef.current.submit()
                          );
                        }}
                        okText="Sí"
                        cancelText="No"
                      >
                        <ButtonItem
                          type="primary"
                          cyanB
                          disabled={this.state.uuidDuplicado}
                        >
                          {this.state.editarOC ? "Editar Orden y Recibir" : "Crear Ajuste y Recibir"}
                        </ButtonItem>
                      </Popconfirm>
                    </>
                  ) : (
                    <ButtonItem
                      type="primary"
                      cyanB
                      htmlType="submit"
                      disabled={this.state.uuidDuplicado}
                    >
                      Recibir
                    </ButtonItem>
                  )
                }
              />
            </Form>
          </Spin>
        </div>
        <RelacionarEntregasModal
          visible={this.state.entregasVisible}
          ordenesDeCompraIds={[this.state.id]}
          renglonesFactura={
            this.state.entregasVisible ? this.renglonesConCantidadAFacturar() : []
          }
          seleccionInicial={this.state.entregasSeleccionadas}
          onCancel={() => this.setState({ entregasVisible: false })}
          onConfirm={(seleccion) =>
            this.setState({ entregasSeleccionadas: seleccion, entregasVisible: false })
          }
        />
        <SeleccionarXmlModal
          visible={this.state.seleccionarXmlVisible}
          proveedorRfc={this.state.datosOrdenDeCompra?.proveedor?.rfc}
          onCancel={() => this.setState({ seleccionarXmlVisible: false })}
          onSelect={async ({ fileName, fileData }) => {
            this.setState({ seleccionarXmlVisible: false });
            await this.leerXmlData({ fileName, fileData });
          }}
        />
        <ManualMatchModal
          visible={this.state.emparejarVisible}
          conceptosXML={this.state.conceptosXML}
          odcPendientes={this.state.odcPendientes}
          mapeos={this.state.mapeos}
          puedeAgregarAOC={
            this.state.estadoOC === 1 && this.state.estadoFactura === 0
          }
          onCancel={() => this.setState({ emparejarVisible: false })}
          onConfirm={async (mapeosConfirmados, insumosAgregarAOC = []) => {
            // insumosNuevos viene del backend con la OC completa (renglones
            // existentes + los recién agregados). Lo guardamos aquí para
            // mergearlo después al form.
            let insumosOCActualizados = null;

            // Si el usuario marcó insumos del XML para agregarlos a la OC,
            // mandarlos al backend antes de aplicar los mapeos.
            if (insumosAgregarAOC.length > 0) {
              try {
                this.setState({ loading: true });
                const res = await axios.post(
                  "ordenesdecompra/agregarInsumosAOrdenDeCompra",
                  {
                    empresaId: this.props.empresaId,
                    ordenDeCompraId: this.state.id,
                    insumos: insumosAgregarAOC.map((it) => ({
                      insumoId: it.insumoId,
                      clave: it.clave,
                      descripcion: it.descripcion,
                      cantidad: it.cantidad,
                      precioUnitario: it.valorUnitario,
                      descuento: it.descuento || 0,
                      impuestos: it.impuestos || 0,
                    })),
                  },
                  { headers: this.props.headersToken }
                );
                if (res.data.success !== 2) {
                  this.setState({ loading: false });
                  return message.error(
                    res.data.err ||
                      "No se pudieron agregar los insumos a la orden de compra"
                  );
                }
                // Mismo mapeo que se hace al cargar la OC inicialmente
                insumosOCActualizados = (res.data.insumosNuevos || []).map(
                  (value) => {
                    return {
                      ...value,
                      recibidoFacturas: value.recibidoFacturas
                        ? value.recibidoFacturas
                        : 0,
                      precioUnitarioAjustadoOC:
                        value.precioUnitario * (1 - value.descuento / 100),
                    };
                  }
                );
                // Actualizar también los insumos dentro de datosOrdenDeCompra
                // (sin tocar el resto de campos de la OC) y la lista global de
                // insumos disponibles (todasInsumos / objetoInsumos).
                this.setState((state) => ({
                  datosOrdenDeCompra: {
                    ...state.datosOrdenDeCompra,
                    ...res.data.ordenDeCompra,
                  },
                  todasInsumos: res.data.insumos || state.todasInsumos,
                  objetoInsumos: res.data.insumos
                    ? res.data.insumos.map((value) => (
                        <Option value={value._id} key={value._id}>
                          {value.descripcion || value.nombre || value.stringBuscar}
                        </Option>
                      ))
                    : state.objetoInsumos,
                }));
                message.success(
                  `${insumosAgregarAOC.length} insumo(s) agregados a la orden de compra`
                );
              } catch (error) {
                this.setState({ loading: false });
                return message.error(
                  "Error al agregar los insumos a la orden de compra"
                );
              } finally {
                this.setState({ loading: false });
              }
            }

            // Obtener insumos del formulario
            let formInsumos = [
              ...(this.formRef.current.getFieldValue("insumos") || []),
            ];

            // Si el backend devolvió los insumos actualizados de la OC,
            // los usamos como nueva base, preservando los campos transitorios
            // que el flujo del XML ya había puesto en los renglones existentes.
            if (insumosOCActualizados) {
              const transitoriosPorId = {};
              const idsAnteriores = new Set();
              formInsumos.forEach((it) => {
                const key = it._id || it.insumoId;
                if (it._id) idsAnteriores.add(String(it._id));
                if (!key) return;
                transitoriosPorId[key] = {
                  recibir: it.recibir,
                  cantidadXML: it.cantidadXML,
                  precioUnitarioXML: it.precioUnitarioXML,
                  descuentoXML: it.descuentoXML,
                  marcarRojo: it.marcarRojo,
                  marcarAzul: it.marcarAzul,
                  motivo: it.motivo,
                };
              });

              // Cola de XMLs agregados a la OC, agrupados por insumoId, para
              // pre-llenar las cantidades/precio en los renglones nuevos.
              const xmlPorInsumoId = {};
              insumosAgregarAOC.forEach((x) => {
                const k = String(x.insumoId);
                if (!xmlPorInsumoId[k]) xmlPorInsumoId[k] = [];
                xmlPorInsumoId[k].push(x);
              });

              formInsumos = insumosOCActualizados.map((it) => {
                const key = it._id || it.insumoId;
                const esNuevo =
                  it._id && !idsAnteriores.has(String(it._id));
                if (esNuevo) {
                  const cola = xmlPorInsumoId[String(it.insumoId)] || [];
                  const xmlOrigen = cola.shift();
                  if (xmlOrigen) {
                    return {
                      ...it,
                      recibir: round2Decimals(xmlOrigen.cantidad),
                      cantidadXML: round2Decimals(xmlOrigen.cantidad),
                      precioUnitarioXML: round6Decimals(
                        xmlOrigen.valorUnitario
                      ),
                      descuentoXML: round2Decimals(xmlOrigen.descuento || 0),
                    };
                  }
                }
                const transit = transitoriosPorId[key] || {};
                return { ...it, ...transit };
              });
              this.formRef.current.setFieldsValue({ insumos: formInsumos });
            }

            const tolerancia = 0.01;


            // Aplica cada mapeo
            for (const m of mapeosConfirmados) {
              const odc = this.state.odcPendientes[m.odcIdx];
              const idxForm = odc.idx;

              // Calcular cantidad disponible en la línea de OC
              // const disponible = round2Decimals(
              //   (formInsumos[idxForm].cantidad) -
              //   (formInsumos[idxForm].recibir || 0)
              // );
              const disponible = round2Decimals(
                (formInsumos[idxForm].cantidad - formInsumos[idxForm].recibidoFacturas) -
                (formInsumos[idxForm].recibir || 0)
              );

              const cantidadARecibir = round2Decimals(m.cantidadARecibir || 0);

              // Asignar cantidad a recibir
              formInsumos[idxForm].recibir = round2Decimals(
                (formInsumos[idxForm].recibir || 0) + cantidadARecibir
              );

              // Guardar datos del XML para comparación
              formInsumos[idxForm].precioUnitarioXML = round6Decimals(m.precioUnitario || 0);
              formInsumos[idxForm].descuentoXML = round2Decimals(m.descuento || 0);
              formInsumos[idxForm].cantidadXML = round2Decimals(
                (formInsumos[idxForm].cantidadXML || 0) + cantidadARecibir
              );;

              // MARCAR EN ROJO: Si la cantidad excede lo disponible
              if (cantidadARecibir > disponible) {
                formInsumos[idxForm].marcarRojo = true;
              }

              // MARCAR EN AZUL: Si el precio del XML no coincide con el de la OC
              const precioXmlNeto = (m.precioUnitario || 0);
              const precioOC = (formInsumos[idxForm].precioUnitarioAjustadoOC || 0);
              const preciosCoinciden = Math.abs(precioOC - precioXmlNeto) < tolerancia;

              if (!preciosCoinciden) {
                formInsumos[idxForm].marcarAzul = true;
              }

              // Guardar motivo si existe
              if (m.motivo) {
                formInsumos[idxForm].motivo = m.motivo;
              }
            }

            // Actualizar formulario
            this.formRef.current.setFieldsValue({
              insumos: formInsumos,
              ajusteSubtotal: 0
            });

            this.setState({
              emparejarVisible: false,
              mapeos: mapeosConfirmados,
            });
          }}
        />
        <ModalDiagnosticoCuadre
          visible={this.state.modalDiagnosticoVisible}
          diagnostico={this.state.diagnostico}
          onCancel={() => this.setState({ modalDiagnosticoVisible: false })}
          onAplicarAjuste={() => {
            this.setState({ modalDiagnosticoVisible: false });
            this.ajustarTotalesAutomaticamente(this.state.ajusteContexto);
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    escuela: state.empresa.escuela,
    vencimientoDesdeRecepcionFactura: state.empresa.vencimientoDesdeRecepcionFactura,
  };
};

export default connect(mapStateToProps)(RecibirFactura);
